import React, { forwardRef, useState, useEffect, Fragment } from "react";
import FormItem from "antd/es/form/FormItem";
import Title from 'antd/es/typography/Title';
import { Col, Row, Typography, Button } from 'antd';
import { Avatar } from 'antd';
import AvatarButton from 'ReusableComponents/AvatarButton/AvatarButton';
import unescape from "lodash/unescape";
import { intToAlpha } from 'lib';

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, questionsKey, language, onCheckAnswer, checkAnswer } = props,
    { required, questions, defaultValue, id, mediaFiles, response } = inputData,
    { getFieldDecorator } = form;
  const [activeButton, setActiveButton] = useState(response);
  const dangerouslySetInnerHTML = unescape(questions[language])

  useEffect(() => {
    if (checkAnswer) {
      onCheckAnswer(id, activeButton, questionsKey);
    }
  }, [checkAnswer]);

  return (
    <Fragment>
      {
        dangerouslySetInnerHTML !== "<p><br></p>" ?
        <Row type="flex" justify="center" align="middle">
          <Col>
            <Title><span dangerouslySetInnerHTML={{__html: dangerouslySetInnerHTML}} /></Title>
          </Col>
        </Row> :
        null
      }
      <Row style={{ textAlign: "center" }} type="flex" justify="center">
        {
          mediaFiles[0].is_inside ?
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[0].src}
              title={intToAlpha(0)}
              setActiveButton={()=>setActiveButton(0)}
              index={0}
              activeButton={activeButton}
              correctAnswer={mediaFiles[0].is_answer}
              checkAnswer={checkAnswer}
            />
          </Col> :
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[0].src}
              title={mediaFiles[0].title}
              setActiveButton={()=>setActiveButton(0)}
              index={0}
              activeButton={activeButton}
              correctAnswer={mediaFiles[0].is_answer}
              checkAnswer={checkAnswer}
            />
            {
              mediaFiles[0].show_title && (
                <Typography.Title level={4}>
                  {mediaFiles[0].title}
                </Typography.Title>
              )
            }
          </Col>
        }
        {
          mediaFiles[1].is_inside ?
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[1].src}
              title={intToAlpha(1)}
              setActiveButton={()=>setActiveButton(1)}
              index={1}
              activeButton={activeButton}
              correctAnswer={mediaFiles[1].is_answer}
              checkAnswer={checkAnswer}
            />
          </Col> :
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[1].src}
              title={mediaFiles[1].title}
              setActiveButton={()=>setActiveButton(1)}
              index={1}
              activeButton={activeButton}
              correctAnswer={mediaFiles[1].is_answer}
              checkAnswer={checkAnswer}
            />
            {
              mediaFiles[1].show_title && (
                <Typography.Title level={4}>
                  {mediaFiles[1].title}
                </Typography.Title>
              )
            }
          </Col>
        }
      </Row>
      <Row style={{ textAlign: "center" }} type="flex" justify="center">
        {
          mediaFiles[2].is_inside ?
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[2].src}
              title={intToAlpha(2)}
              setActiveButton={()=>setActiveButton(2)}
              index={2}
              activeButton={activeButton}
              correctAnswer={mediaFiles[2].is_answer}
              checkAnswer={checkAnswer}
            />
          </Col> :
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[2].src}
              title={mediaFiles[2].title}
              setActiveButton={()=>setActiveButton(2)}
              index={2}
              activeButton={activeButton}
              correctAnswer={mediaFiles[2].is_answer}
              checkAnswer={checkAnswer}
            />
            {
              mediaFiles[2].show_title && (
                <Typography.Title level={4}>
                  {mediaFiles[2].title}
                </Typography.Title>
              )
            }
          </Col>
        }
        {
          mediaFiles[3].is_inside ?
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[3].src}
              title={intToAlpha(3)}
              setActiveButton={()=>setActiveButton(3)}
              index={3}
              activeButton={activeButton}
              correctAnswer={mediaFiles[3].is_answer}
              checkAnswer={checkAnswer}
            />
          </Col> :
          <Col span={4} style={{ margin: '8px 0px' }}>
            <AvatarButton
              src={mediaFiles[3].src}
              title={mediaFiles[3].title}
              setActiveButton={()=>setActiveButton(3)}
              index={3}
              activeButton={activeButton}
              correctAnswer={mediaFiles[3].is_answer}
              checkAnswer={checkAnswer}
            />
            {
              mediaFiles[3].show_title && (
                <Typography.Title level={4}>
                  {mediaFiles[3].title}
                </Typography.Title>
              )
            }
          </Col>
        }
      </Row>
    </Fragment>
  );
});
